<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.02981 10.4957H6.80879C5.22748 10.4957 3.9364 11.7838 3.9364 13.3721V17.2213C3.9364 18.6975 5.1374 19.8945 6.60863 19.8945H16.9573C17.7779 19.8945 18.5786 19.5663 19.1591 18.9808C19.7496 18.3953 20.0698 17.6006 20.0698 16.7729V6.58656C20.0698 5.21872 18.9689 4.10999 17.5978 4.10999H10.5119C9.14074 4.10999 8.02981 5.21872 8.02981 6.58656V10.4957ZM6.60863 18.6435C5.82798 18.6435 5.18744 18.007 5.18744 17.2213C5.18744 16.0483 5.18744 14.5761 5.18744 13.3721C5.18744 12.4744 5.91805 11.7468 6.80879 11.7468H8.02981V17.2213C8.02981 18.007 7.39929 18.6435 6.60863 18.6435ZM11.5327 16.3716H16.3768C16.717 16.3716 16.9973 16.0914 16.9973 15.7461C16.9973 15.4008 16.717 15.1206 16.3768 15.1206H11.5327C11.1824 15.1206 10.9022 15.4008 10.9022 15.7461C10.9022 16.0914 11.1824 16.3716 11.5327 16.3716ZM11.5327 14.1027H16.3768C16.717 14.1027 16.9973 13.8225 16.9973 13.4772C16.9973 13.1329 16.717 12.8517 16.3768 12.8517H11.5327C11.1824 12.8517 10.9022 13.1329 10.9022 13.4772C10.9022 13.8225 11.1824 14.1027 11.5327 14.1027ZM11.5327 10.0894H13.9547C14.295 10.0894 14.5753 9.80914 14.5753 9.46385C14.5753 9.11856 14.295 8.83833 13.9547 8.83833H11.5327C11.1824 8.83833 10.9022 9.11856 10.9022 9.46385C10.9022 9.80914 11.1824 10.0894 11.5327 10.0894Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArticlesSelected'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
